/* ============================================================
   OLFATTO · App JS — Reveal on scroll observer
   Aplica .in a [data-olfatto-reveal] cuando entra al viewport.
   Por defecto, los elementos son visibles. El observer los oculta
   primero (--pending) y luego los revela al hacer scroll.
   ============================================================ */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  function init() {
    var els = document.querySelectorAll('[data-olfatto-reveal]:not(.in):not(.olfatto-reveal--pending)');
    if (els.length === 0) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('olfatto-reveal--pending');
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Si ya está dentro del viewport al cargar, mostrar de inmediato
      if (rect.top < vh * 0.95) {
        el.classList.add('in');
      } else {
        el.classList.add('olfatto-reveal--pending');
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-escanear al navegar internamente (Shopify section render API)
  document.addEventListener('shopify:section:load', init);
})();
